<div [ngClass]="['status-container', statusNamespace.getClassStatus(status)]">
    <mat-icon class="notranslate material-icons-outlined">{{statusNamespace.getIconStatus(status)}}</mat-icon>
    <span>{{status | enumString:statusNamespace}}</span>
</div>
